import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "uk-flex uk-flex-column" }
const _hoisted_2 = {
  class: "uk-card uk-card-default uk-grid-collapse uk-child-width-1-2@s uk-margin",
  "uk-grid": ""
}
const _hoisted_3 = { class: "uk-card-media-left uk-cover-container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "uk-card-body" }
const _hoisted_6 = { class: "uk-flex uk-flex-column uk-align-left@l uk-margin-left" }
const _hoisted_7 = { class: "uk-text-bold" }
const _hoisted_8 = { class: "uk-text-bold" }
const _hoisted_9 = { class: "uk-flex uk-flex-column uk-align-left@l uk-margin-left" }
const _hoisted_10 = { class: "uk-text-bold" }
const _hoisted_11 = { class: "uk-text-bold" }
const _hoisted_12 = { class: "uk-flex uk-flex-column uk-align-left@l uk-margin-left" }
const _hoisted_13 = { class: "uk-text-bold" }
const _hoisted_14 = { class: "uk-card uk-card-default uk-card-body uk-width-1-1 uk-margin" }
const _hoisted_15 = {
  class: "uk-grid-medium uk-child-width-expand@s uk-text-center",
  "uk-grid": ""
}
const _hoisted_16 = { class: "uk-flex uk-flex-column uk-margin-left" }
const _hoisted_17 = { class: "uk-text-bold" }
const _hoisted_18 = { class: "uk-text-bold uk-margin-remove" }
const _hoisted_19 = { class: "uk-flex uk-flex-column uk-margin-left" }
const _hoisted_20 = { class: "uk-text-bold" }
const _hoisted_21 = { class: "uk-text-bold uk-margin-remove" }
const _hoisted_22 = { class: "uk-flex uk-flex-column uk-margin-left" }
const _hoisted_23 = { class: "uk-text-bold" }
const _hoisted_24 = { class: "uk-text-bold" }
const _hoisted_25 = { class: "uk-flex uk-flex-column uk-margin-left" }
const _hoisted_26 = { class: "uk-text-bold uk-text-break" }
const _hoisted_27 = { class: "uk-card uk-card-default uk-card-body uk-width-1-1 uk-margin" }
const _hoisted_28 = {
  class: "uk-grid-medium uk-child-width-expand@s uk-text-center",
  "uk-grid": ""
}
const _hoisted_29 = { class: "uk-flex uk-flex-column uk-margin-left" }
const _hoisted_30 = { class: "uk-text-bold" }
const _hoisted_31 = { class: "uk-text-bold uk-margin-remove" }
const _hoisted_32 = { class: "uk-flex uk-flex-column uk-margin-left" }
const _hoisted_33 = { class: "uk-text-bold" }
const _hoisted_34 = { class: "uk-text-bold uk-margin-remove" }
const _hoisted_35 = { class: "uk-flex uk-flex-column uk-margin-left" }
const _hoisted_36 = { class: "uk-text-bold" }
const _hoisted_37 = { class: "uk-text-bold uk-margin-remove" }
const _hoisted_38 = {
  class: "uk-grid-medium uk-child-width-expand@s uk-text-center",
  "uk-grid": ""
}
const _hoisted_39 = { class: "uk-flex uk-flex-column uk-margin-left" }
const _hoisted_40 = { class: "uk-text-bold" }
const _hoisted_41 = { class: "uk-text-bold uk-margin-remove" }
const _hoisted_42 = { class: "uk-flex uk-flex-column uk-margin-left" }
const _hoisted_43 = { class: "uk-text-bold" }
const _hoisted_44 = { class: "uk-text-bold uk-margin-remove" }
const _hoisted_45 = { class: "uk-flex uk-flex-column uk-margin-left" }
const _hoisted_46 = { class: "uk-text-bold" }
const _hoisted_47 = { class: "uk-text-bold uk-margin-remove" }
const _hoisted_48 = {
  class: "uk-grid-medium uk-child-width-expand@s uk-text-center",
  "uk-grid": ""
}
const _hoisted_49 = { class: "uk-flex uk-flex-column uk-margin-left" }
const _hoisted_50 = { class: "uk-text-bold" }

import {useStore} from "vuex";
import Room from "@/models/Room";
import Stay from "@/models/Stay";
import Customer from "@/models/Customer";


export default /*@__PURE__*/_defineComponent({
  __name: 'BookingResume',
  setup(__props) {

const store = useStore();
const baseUri = process.env.VUE_APP_API_ASSET_URL;
const room:Room = store.getters['room/getRoomChoose']
const stay:Stay = store.getters['booking/getStay']
const customer:Customer =store.getters['booking/getCustomer']

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _unref(room)?.room_photos ?  _unref(baseUri)+_unref(room).room_photos[0] : '',
          alt: "room",
          "uk-cover": ""
        }, null, 8, _hoisted_4),
        _cache[0] || (_cache[0] = _createElementVNode("canvas", {
          width: "500",
          height: "200"
        }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "uk-card-title" }, "Appartement", -1)),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", null, [
            _cache[1] || (_cache[1] = _createTextVNode("Numéro: ", -1)),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(room).room_name), 1)
          ]),
          _createElementVNode("p", null, [
            _cache[2] || (_cache[2] = _createTextVNode("Nuitée: ", -1)),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(room).room_total_price) + " FCFA", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("p", null, [
            _cache[3] || (_cache[3] = _createTextVNode("Type: ", -1)),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(room).room_type.room_type_name), 1)
          ]),
          _createElementVNode("p", null, [
            _cache[4] || (_cache[4] = _createTextVNode("Invité(s): ", -1)),
            _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(stay).stays_number_of_occupants) + " personne(s)", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("p", null, [
            _cache[5] || (_cache[5] = _createTextVNode("Enfant(s): ", -1)),
            _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(stay).stays_number_of_children) + " enfant(s)", 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _cache[15] || (_cache[15] = _createElementVNode("h3", { class: "uk-card-title" }, "Séjour", -1)),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("p", null, [
              _cache[7] || (_cache[7] = _createTextVNode("Entrée: ", -1)),
              _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(stay).stays_enter_date), 1)
            ]),
            _createElementVNode("p", null, [
              _cache[8] || (_cache[8] = _createTextVNode("Sortir: ", -1)),
              _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(stay).stays_leaving_date), 1)
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("p", null, [
              _cache[9] || (_cache[9] = _createTextVNode("Nombre de nuitée: ", -1)),
              _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(stay).stays_number_of_days), 1)
            ]),
            _createElementVNode("p", null, [
              _cache[10] || (_cache[10] = _createTextVNode("Prix du séjour: ", -1)),
              _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(stay).stays_total_price_to_pay) + " FCFA", 1)
            ])
          ])
        ]),
        _cache[13] || (_cache[13] = _createElementVNode("div", null, null, -1)),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("p", null, [
              _cache[11] || (_cache[11] = _createTextVNode("Type de séjour: ", -1)),
              _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(stay).stay_type?.stay_typ_name), 1)
            ]),
            _createElementVNode("p", null, [
              _cache[12] || (_cache[12] = _createTextVNode("Mode de paiement: ", -1)),
              _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(stay).pay_mode), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _cache[14] || (_cache[14] = _createElementVNode("h5", null, "Note/Préférence", -1)),
        _createElementVNode("p", _hoisted_26, _toDisplayString(_unref(stay).stays_preference), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _cache[29] || (_cache[29] = _createElementVNode("h3", { class: "uk-card-title" }, "Informations personnels", -1)),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("p", null, [
              _cache[16] || (_cache[16] = _createTextVNode("Civilité: ", -1)),
              _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(customer).cust_sexe), 1)
            ]),
            _createElementVNode("p", null, [
              _cache[17] || (_cache[17] = _createTextVNode("Nom: ", -1)),
              _createElementVNode("span", _hoisted_31, _toDisplayString(_unref(customer).cust_lastname), 1)
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("p", null, [
              _cache[18] || (_cache[18] = _createTextVNode("Prénom: ", -1)),
              _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(customer).cust_firstname), 1)
            ]),
            _createElementVNode("p", null, [
              _cache[19] || (_cache[19] = _createTextVNode("Date d'anniversaire: ", -1)),
              _createElementVNode("span", _hoisted_34, _toDisplayString(_unref(customer).cust_birthday), 1)
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("p", null, [
              _cache[20] || (_cache[20] = _createTextVNode("Type de pièce d'identité: ", -1)),
              _createElementVNode("span", _hoisted_36, _toDisplayString(_unref(customer).cust_type_id), 1)
            ]),
            _createElementVNode("p", null, [
              _cache[21] || (_cache[21] = _createTextVNode("Réference de la pièce: ", -1)),
              _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(customer).cust_reference_id), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("p", null, [
              _cache[22] || (_cache[22] = _createTextVNode("Contact: ", -1)),
              _createElementVNode("span", _hoisted_40, _toDisplayString(_unref(customer).cust_contact), 1)
            ]),
            _createElementVNode("p", null, [
              _cache[23] || (_cache[23] = _createTextVNode("Lieu de residence: ", -1)),
              _createElementVNode("span", _hoisted_41, _toDisplayString(_unref(customer).cust_place_residence), 1)
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("p", null, [
              _cache[24] || (_cache[24] = _createTextVNode("Email: ", -1)),
              _createElementVNode("span", _hoisted_43, _toDisplayString(_unref(customer).cust_email), 1)
            ]),
            _createElementVNode("p", null, [
              _cache[25] || (_cache[25] = _createTextVNode("Profession: ", -1)),
              _createElementVNode("span", _hoisted_44, _toDisplayString(_unref(customer).cust_job), 1)
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("p", null, [
              _cache[26] || (_cache[26] = _createTextVNode("Pays: ", -1)),
              _createElementVNode("span", _hoisted_46, _toDisplayString(_unref(customer).cust_country), 1)
            ]),
            _createElementVNode("p", null, [
              _cache[27] || (_cache[27] = _createTextVNode("Ville: ", -1)),
              _createElementVNode("span", _hoisted_47, _toDisplayString(_unref(customer).cust_city), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("p", null, [
              _cache[28] || (_cache[28] = _createTextVNode("Nationalité: ", -1)),
              _createElementVNode("span", _hoisted_50, _toDisplayString(_unref(customer).cust_nationality), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})